import { render, staticRenderFns } from "./BaseFileDownload.vue?vue&type=template&id=3083ecb7&"
import script from "./BaseFileDownload.vue?vue&type=script&lang=ts&"
export * from "./BaseFileDownload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports